import { createFileRoute } from "@tanstack/react-router";
import { requireAuth } from "@/common/routes/requireAuth";
import { useOrganization } from "@/pages/organizations/detail";
import OverviewPage from "@/pages/organizations/detail/overview";

export const Route = createFileRoute("/app/organizations/$organizationId/overview/")({
  beforeLoad: ({ context }) => {
    requireAuth(context);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const activeTab = null; // No tab param - this is the default tab
  const { organization, userCanViewAssessments, userCanEditAssessments } = useOrganization();

  return (
    <OverviewPage
      activeTab={activeTab}
      organization={organization}
      userCanEditAssessments={userCanEditAssessments}
      userCanViewAssessments={userCanViewAssessments}
    />
  );
}
